webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingSpinner_vue__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5baf8e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingSpinner_vue__ = __webpack_require__(159);
function injectStyle (ssrContext) {
  __webpack_require__(157)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c5baf8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5baf8e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_auth__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controllers_users__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__controllers_persons__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controllers_slides__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__controllers_categories__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__controllers_entries__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__controllers_pages__ = __webpack_require__(166);








/* harmony default export */ __webpack_exports__["a"] = ({
  auth: __WEBPACK_IMPORTED_MODULE_0__controllers_auth__["a" /* default */],
  users: __WEBPACK_IMPORTED_MODULE_1__controllers_users__["a" /* default */],
  persons: __WEBPACK_IMPORTED_MODULE_2__controllers_persons__["a" /* default */],
  slides: __WEBPACK_IMPORTED_MODULE_3__controllers_slides__["a" /* default */],
  categories: __WEBPACK_IMPORTED_MODULE_4__controllers_categories__["a" /* default */],
  entries: __WEBPACK_IMPORTED_MODULE_5__controllers_entries__["a" /* default */],
  pages: __WEBPACK_IMPORTED_MODULE_6__controllers_pages__["a" /* default */]
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(9);



var API_URL = "/api/v1";

/* harmony default export */ __webpack_exports__["a"] = ({
  postRequest: function postRequest(route, addAuthHeader, body, callback) {
    var options = { emulateJSON: true };
    if (addAuthHeader) {
      options = { emulateJSON: true, headers: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].getAuthHeader() };
    }
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(API_URL + route, body, options).then(function (response) {
      callback(response, false);
    }, function (response) {
      callback(response, true);
    });
  },
  getRequest: function getRequest(route, addAuthHeader, callback) {
    var options = {};
    if (addAuthHeader) {
      options = { headers: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].getAuthHeader() };
    }
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(API_URL + route, options).then(function (response) {
      callback(response, false);
    }, function (response) {
      callback(response, true);
    });
  },
  deleteRequest: function deleteRequest(route, addAuthHeader, callback) {
    var options = {};
    if (addAuthHeader) {
      options = { headers: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].getAuthHeader() };
    }
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.delete(API_URL + route, options).then(function (response) {
      callback(response, false);
    }, function (response) {
      callback(response, true);
    });
  },
  patchRequest: function patchRequest(route, addAuthHeader, body, callback) {
    var options = { emulateJSON: true };
    if (addAuthHeader) {
      options = { emulateJSON: true, headers: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].getAuthHeader() };
    }
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.patch(API_URL + route, body, options).then(function (response) {
      callback(response, false);
    }, function (response) {
      callback(response, true);
    });
  },
  putRequest: function putRequest(route, addAuthHeader, body, callback) {
    var options = { emulateJSON: true };
    if (addAuthHeader) {
      options = { emulateJSON: true, headers: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].getAuthHeader() };
    }
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(API_URL + route, body, options).then(function (response) {
      callback(response, false);
    }, function (response) {
      callback(response, true);
    });
  }
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bioplan_signet.600ab45.png";

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  token: null,
  getAuthHeader: function getAuthHeader() {
    return {
      Authorization: 'Bearer ' + this.token
    };
  },
  setToken: function setToken(newToken) {
    if (this.token !== newToken) {
      this.token = newToken;
      if (newToken) {
        localStorage.setItem('bioplan_token', newToken);
      } else {
        localStorage.removeItem('bioplan_token');
      }
    }
  },
  checkLocalToken: function checkLocalToken() {
    var localToken = localStorage.getItem('bioplan_token');
    if (localToken) {
      this.setToken(localToken);
      return true;
    } else {
      return false;
    }
  }
});

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_auth__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filters__ = __webpack_require__(254);












Object(__WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.fullPath.indexOf('admin') >= 0 && to.name !== 'Login' && !__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.auth.token) {
    next('/admin');
  } else {
    next();
  }
});

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  next();
});

if (__WEBPACK_IMPORTED_MODULE_8__services_auth__["a" /* default */].checkLocalToken()) {
  __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('auth/LOGIN', __WEBPACK_IMPORTED_MODULE_8__services_auth__["a" /* default */].token);
}

var eventBus = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]();
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$eventBus = eventBus;

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forEach__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__find__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__find__);



/***/ }),
/* 141 */
/***/ (function(module, exports) {


if (!Array.prototype.forEach) {

    Array.prototype.forEach = function (callback, thisArg) {

        var T, k;

        if (this === null) {
            throw new TypeError(' this is null or not defined');
        }

        var O = Object(this);

        var len = O.length >>> 0;

        if (typeof callback !== "function") {
            throw new TypeError(callback + ' is not a function');
        }

        if (arguments.length > 1) {
            T = thisArg;
        }

        k = 0;

        while (k < len) {

            var kValue;

            if (k in O) {
                kValue = O[k];

                callback.call(T, kValue, k, O);
            }

            k++;
        }
    };
}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

if (!Array.prototype.find) {
  Array.prototype.find = function (predicate) {
    'use strict';

    if (this == null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    var list = Object(this);
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    var value;

    for (var i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return value;
      }
    }
    return undefined;
  };
}

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(151);
function injectStyle (ssrContext) {
  __webpack_require__(148)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */,
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_HomeSlider__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Archive__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Contact__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Office__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_admin_AdminMain__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_admin_Login__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_admin_AdminSlides__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_admin_AdminPersons__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_admin_AdminCategories__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_admin_AdminUsers__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_admin_AdminEntries__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_admin_AdminPages__ = __webpack_require__(237);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'HomeSlider',
    component: __WEBPACK_IMPORTED_MODULE_2__components_pages_HomeSlider__["a" /* default */]
  }, {
    path: '/archive',
    name: 'Archive',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_Archive__["a" /* default */]
  }, {
    path: '/archive/:id',
    name: 'ArchiveEntry',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_Archive__["a" /* default */]
  }, {
    path: '/office',
    name: 'Office',
    component: __WEBPACK_IMPORTED_MODULE_5__components_pages_Office__["a" /* default */]
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_4__components_pages_Contact__["a" /* default */]
  }, {
    path: '/admin',
    component: __WEBPACK_IMPORTED_MODULE_6__components_pages_admin_AdminMain__["a" /* default */],
    children: [{
      path: '',
      name: 'Login',
      component: __WEBPACK_IMPORTED_MODULE_7__components_pages_admin_Login__["a" /* default */]
    }, {
      path: 'users',
      name: 'AdminUsers',
      component: __WEBPACK_IMPORTED_MODULE_11__components_pages_admin_AdminUsers__["a" /* default */]
    }, {
      path: 'slides',
      name: 'AdminSlides',
      component: __WEBPACK_IMPORTED_MODULE_8__components_pages_admin_AdminSlides__["a" /* default */]
    }, {
      path: 'persons',
      name: 'AdminPersons',
      component: __WEBPACK_IMPORTED_MODULE_9__components_pages_admin_AdminPersons__["a" /* default */]
    }, {
      path: 'categories',
      name: 'AdminCategories',
      component: __WEBPACK_IMPORTED_MODULE_10__components_pages_admin_AdminCategories__["a" /* default */]
    }, {
      path: 'entries',
      name: 'AdminEntries',
      component: __WEBPACK_IMPORTED_MODULE_12__components_pages_admin_AdminEntries__["a" /* default */]
    }, {
      path: 'pages',
      name: 'AdminPages',
      component: __WEBPACK_IMPORTED_MODULE_13__components_pages_admin_AdminPages__["a" /* default */]
    }]
  }]
}));

/***/ }),
/* 153 */,
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeSlider_vue__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_495eba8d_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_HomeSlider_vue__ = __webpack_require__(167);
function injectStyle (ssrContext) {
  __webpack_require__(155)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-495eba8d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_495eba8d_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_HomeSlider_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_rest__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'component',
  components: {
    LoadingSpinner: __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__["a" /* default */]
  },
  data: function data() {
    return {
      slides: [],
      currentSlideIndex: 0,
      slidesLoading: true
    };
  },

  computed: {
    currentSlide: function currentSlide() {
      if (!this.slides || this.slides.length <= 0 || this.currentSlideIndex >= this.slides.length) {
        return null;
      }
      return this.slides[this.currentSlideIndex];
    },
    hasNextSlide: function hasNextSlide() {
      if (!this.slides || this.slides.length <= 0 || !this.currentSlide) {
        return false;
      }
      return this.currentSlideIndex < this.slides.length - 1;
    },
    hasPreviousSlide: function hasPreviousSlide() {
      if (!this.slides || this.slides.length <= 0 || !this.currentSlide) {
        return false;
      }
      return this.currentSlideIndex > 0;
    }
  },
  methods: {
    loadSlides: function loadSlides() {
      var _this = this;

      this.slidesLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].slides.all(function (response, hasError) {
        if (hasError) {
          return;
        }
        _this.slides = response.data;
        if (_this.slides && _this.slides.length > 0) {
          _this.currentSlideIndex = 0;
          _this.slidesLoading = false;
        }
      });
    },
    goToArchive: function goToArchive() {
      this.$router.push({ name: 'Archive' });
    }
  },
  mounted: function mounted() {
    this.loadSlides();
  }
});

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoadingSpinner'
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "sk-circle"
  }, [_c('div', {
    staticClass: "sk-circle1 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle2 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle3 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle4 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle5 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle6 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle7 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle8 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle9 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle10 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle11 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle12 sk-child"
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  controller: '/auth',
  login: function login(username, password, callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].postRequest(this.controller + '/login', false, { username: username, password: password }, callback);
  },
  refresh: function refresh(callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].postRequest(this.controller + '/refresh', true, null, callback);
  }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  controller: '/users',
  all: function all(callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].getRequest(this.controller, true, callback);
  },
  add: function add(user, callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].postRequest(this.controller, true, user, callback);
  },
  update: function update(user, callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].putRequest(this.controller + '/' + user.id, true, user, callback);
  },
  delete: function _delete(id, callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].deleteRequest(this.controller + '/' + id, true, callback);
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  controller: '/persons',
  all: function all(callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].getRequest(this.controller, false, callback);
  },
  delete: function _delete(id, callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].deleteRequest(this.controller + '/' + id, true, callback);
  },
  update: function update(person, img, callback) {
    var data = new FormData();
    data.append('id', person.id);
    data.append('name', person.name);
    data.append('title', person.title);
    data.append('color', person.color);
    data.append('img', img);
    data.append('_method', 'PUT');
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].postRequest(this.controller + '/' + person.id, true, data, callback);
  },
  add: function add(person, img, callback) {
    var data = new FormData();
    data.append('id', person.id);
    data.append('name', person.name);
    data.append('title', person.title);
    data.append('color', person.color);
    data.append('img', img);
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].postRequest(this.controller, true, data, callback);
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  controller: '/slides',
  all: function all(callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].getRequest(this.controller, false, callback);
  },
  delete: function _delete(id, callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].deleteRequest(this.controller + '/' + id, true, callback);
  },
  update: function update(slide, img, callback) {
    var data = new FormData();
    data.append('id', slide.id);
    data.append('title', slide.title);
    data.append('description', slide.description);
    data.append('img', img);
    data.append('_method', 'PUT');
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].postRequest(this.controller + '/' + slide.id, true, data, callback);
  },
  add: function add(slide, img, callback) {
    var data = new FormData();
    data.append('id', slide.id);
    data.append('title', slide.title);
    data.append('description', slide.description);
    data.append('img', img);
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].postRequest(this.controller, true, data, callback);
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  controller: '/categories',
  all: function all(callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].getRequest(this.controller, false, callback);
  },
  delete: function _delete(id, callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].deleteRequest(this.controller + '/' + id, true, callback);
  },
  update: function update(category, callback) {
    var data = new FormData();
    data.append('id', category.id);
    data.append('name', category.name);
    data.append('color', category.color);
    data.append('_method', 'PUT');
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].postRequest(this.controller + '/' + category.id, true, data, callback);
  },
  add: function add(category, callback) {
    var data = new FormData();
    data.append('id', category.id);
    data.append('name', category.name);
    data.append('color', category.color);
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].postRequest(this.controller, true, data, callback);
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  controller: '/entries',
  all: function all(callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].getRequest(this.controller, false, callback);
  },
  delete: function _delete(id, callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].deleteRequest(this.controller + '/' + id, true, callback);
  },
  update: function update(entry, callback) {
    var data = new FormData();
    data.append('id', entry.id);
    data.append('title', entry.title);
    data.append('date', entry.date);
    data.append('text', entry.text);
    data.append('no_details', entry.noDetails);
    if (entry.categories) {
      entry.categories.forEach(function (cat) {
        data.append('categories[]', cat.id);
      });
    }
    data.append('_method', 'PUT');
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].postRequest(this.controller + '/' + entry.id, true, data, callback);
  },
  add: function add(entry, callback) {
    var data = new FormData();
    data.append('id', entry.id);
    data.append('title', entry.title);
    data.append('date', entry.date);
    data.append('text', entry.text);
    data.append('no_details', entry.noDetails);
    if (entry.categories) {
      entry.categories.forEach(function (cat) {
        data.append('categories[]', cat.id);
      });
    }
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].postRequest(this.controller, true, data, callback);
  },
  addImage: function addImage(entryId, files, callback) {
    var data = new FormData();
    for (var index = 0; index < files.length; index++) {
      data.append('img[]', files[index]);
    }
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].postRequest(this.controller + '/img/' + entryId, true, data, callback);
  },
  removeImage: function removeImage(id, callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].deleteRequest(this.controller + '/img/' + id, true, callback);
  },
  saveImageMapping: function saveImageMapping(smallImagesArray, mediumImagesArray, largeImagesArray, callback) {
    var smallImages = '';
    var mediumImages = '';
    var largeImages = '';
    smallImagesArray.forEach(function (img) {
      smallImages = smallImages + img.id + ';';
    });
    mediumImagesArray.forEach(function (img) {
      mediumImages = mediumImages + img.id + ';';
    });
    largeImagesArray.forEach(function (img) {
      largeImages = largeImages + img.id + ';';
    });
    var body = {
      smallImages: smallImages,
      mediumImages: mediumImages,
      largeImages: largeImages
    };
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].postRequest(this.controller + '/saveImageMapping', true, body, callback);
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  controller: '/pages',
  all: function all(callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].getRequest(this.controller, true, callback);
  },
  byName: function byName(name, callback) {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].getRequest(this.controller + '/byName/' + name, false, callback);
  },
  update: function update(page, callback) {
    var data = new FormData();
    data.append('id', page.id);
    data.append('name', page.name);
    data.append('content', page.content);
    data.append('_method', 'PUT');
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].postRequest(this.controller + '/' + page.id, true, data, callback);
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(168),
      "role": "button"
    },
    on: {
      "click": _vm.goToArchive
    }
  })]), _vm._v(" "), (_vm.slidesLoading) ? _c('LoadingSpinner') : [_c('div', {
    staticClass: "slider",
    style: ({
      'background-image': 'url(' + _vm.currentSlide.url + ')'
    })
  }, [(_vm.hasPreviousSlide) ? _c('div', {
    staticClass: "left",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.currentSlideIndex--
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasNextSlide) ? _c('div', {
    staticClass: "right",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.currentSlideIndex++
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.hasNextSlide) ? _c('div', {
    staticClass: "right",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.goToArchive
    }
  }) : _vm._e()])], _vm._v(" "), _c('div', {
    staticClass: "information"
  }, [_c('img', {
    staticClass: "signet",
    attrs: {
      "src": __webpack_require__(6)
    }
  }), _vm._v(" "), (_vm.currentSlide) ? _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.currentSlide.title))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.currentSlide.description))])]) : _vm._e()])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Archive_vue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f988925_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Archive_vue__ = __webpack_require__(172);
function injectStyle (ssrContext) {
  __webpack_require__(170)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f988925"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Archive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f988925_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Archive_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_rest__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_marked__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Archive',
  components: {
    LoadingSpinner: __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__["a" /* default */]
  },
  data: function data() {
    return {
      archiveLoading: true,
      archive: [],
      categories: [],
      filterText: '',
      showCategorySelection: false,
      currentCategory: null,
      currentEntry: null,
      pageWidth: 0
    };
  },

  computed: {
    markedEntryText: function markedEntryText() {
      if (!this.currentEntry) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_2_marked___default()(this.currentEntry.text, { sanitize: true, breaks: true });
    },
    currentEntryId: function currentEntryId() {
      return this.$route.params.id;
    },
    currentEntryCategories: function currentEntryCategories() {
      if (!this.currentEntry || !this.currentEntry.categories || this.currentEntry.categories.length < 1) {
        return '';
      }
      return this.currentEntry.categories[0].name;
    },
    imageLayoutOption: function imageLayoutOption() {
      if (!this.currentEntry.images || this.currentEntry.images.length < 1) {
        return 'layout-none';
      }

      var hasLarge = this.currentEntry.images.find(function (img) {
        return img.size === 2;
      }) !== undefined;
      var hasMedium = this.currentEntry.images.find(function (img) {
        return img.size === 1;
      }) !== undefined;
      var hasSmall = this.currentEntry.images.find(function (img) {
        return img.size === null || img.size === 0;
      }) !== undefined;
      if (hasLarge && !hasMedium && !hasSmall) {
        return 'layout-large-only';
      }
      if (!hasLarge && hasMedium && !hasSmall) {
        return 'layout-medium-only';
      }
      if (!hasLarge && !hasMedium && hasSmall) {
        return 'layout-small-only';
      }
      if (!hasLarge && hasMedium && hasSmall) {
        return 'layout-medium-small';
      }
      if (hasLarge && !hasMedium && hasSmall) {
        return 'layout-large-small';
      }
      if (hasLarge && hasMedium && !hasSmall) {
        return 'layout-large-medium';
      }
      return 'layout-all';
    },
    currentEntryImagesSorted: function currentEntryImagesSorted() {
      if (!this.currentEntry.images || this.currentEntry.images.length < 1) {
        return [];
      }
      return this.currentEntry.images.sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      });
    },
    currentEntryImagesLarge: function currentEntryImagesLarge() {
      if (!this.currentEntry.images || this.currentEntry.images.length < 1) {
        return [];
      }
      return this.currentEntry.images.filter(function (img) {
        return img.size === 2;
      }).sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      });
    },
    currentEntryImagesMedium: function currentEntryImagesMedium() {
      if (!this.currentEntry.images || this.currentEntry.images.length < 1) {
        return [];
      }
      return this.currentEntry.images.filter(function (img) {
        return img.size === 1;
      }).sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      });
    },
    currentEntryImagesSmall: function currentEntryImagesSmall() {
      if (!this.currentEntry.images || this.currentEntry.images.length < 1) {
        return [];
      }
      return this.currentEntry.images.filter(function (img) {
        return img.size === null || img.size === 0;
      }).sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      });
    },
    maxColumns: function maxColumns() {
      if (this.pageWidth >= 1200) {
        return 4;
      } else if (this.pageWidth >= 900) {
        return 3;
      } else {
        return 1;
      }
    },
    columns: function columns() {
      var columns = [];
      for (var i = 0; i < this.maxColumns; i++) {
        columns.push([]);
      }
      var entryCount = this.archive.length;
      var perColumn = parseInt(entryCount / this.maxColumns);
      var remaining = entryCount - perColumn * this.maxColumns;
      var lastItem = -1;
      for (var column = 0; column < columns.length; column++) {
        var itemsInThisColumn = perColumn;
        if (remaining > column) {
          itemsInThisColumn++;
        }
        for (var _i = 0; _i < itemsInThisColumn; _i++) {
          var itemIndex = lastItem + 1;
          columns[column].push(this.archive[itemIndex]);
          lastItem++;
        }
      }
      return columns;
    }
  },
  watch: {
    currentEntryId: function currentEntryId() {
      this.currentEntryIdChanged();
    },
    filterText: function filterText() {
      if (this.filterText) {
        this.currentCategory = null;
      }
    },
    currentCategory: function currentCategory() {
      if (this.currentCategory) {
        this.filterText = '';
        if (this.currentEntryId) {
          this.$router.push({ name: 'Archive' });
        }
      }
    }
  },
  methods: {
    currentEntryIdChanged: function currentEntryIdChanged() {
      var _this = this;

      if (!this.currentEntryId) {
        this.currentEntry = null;
      }
      var entry = this.archive.find(function (a) {
        return a.id === parseInt(_this.currentEntryId);
      });
      if (!entry) {
        this.currentEntry = null;
      }
      this.currentEntry = entry;
    },
    loadArchive: function loadArchive() {
      var _this2 = this;

      this.archiveLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].entries.all(function (response, hasError) {
        if (hasError) {
          return;
        }
        var archive = response.body;
        archive = archive.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date);
        });
        _this2.archive = archive;
        _this2.categories = [];
        _this2.archive.forEach(function (a) {
          a.categories.forEach(function (c) {
            var cat = _this2.categories.find(function (entryCategory) {
              return entryCategory.name === c.name;
            });
            if (cat === undefined) {
              _this2.categories.push(c);
            }
          });
        });
        _this2.archiveLoading = false;
        _this2.currentEntryIdChanged();
      });
    },
    showEntry: function showEntry(entry) {
      if (entry.noDetails) {
        return;
      }

      this.$router.push({ name: 'ArchiveEntry', params: { id: entry.id } });
    },
    moveNextEntry: function moveNextEntry() {
      if (!this.currentEntry) {
        return false;
      }
      var index = this.archive.indexOf(this.currentEntry);
      if (index === this.archive.length - 1) {
        index = -1;
      }
      for (var i = index + 1; i < this.archive.length; i++) {
        var entry = this.archive[i];
        var isInCurrentCategory = true;
        if (this.currentCategory) {
          isInCurrentCategory = this.entryInCurrentCategory(entry);
        }
        if (isInCurrentCategory && !entry.noDetails) {
          this.showEntry(entry);
          break;
        } else {
          console.log('Nicht zulässig:', entry.title, isInCurrentCategory, entry.noDetails);
        }
        if (i === this.archive.length - 1) {
          i = -1;
        }
      }
    },
    movePreviousEntry: function movePreviousEntry() {
      if (!this.currentEntry) {
        return false;
      }
      var index = this.archive.indexOf(this.currentEntry);
      if (index === 0) {
        index = this.archive.length;
      }
      for (var i = index - 1; i >= 0; i--) {
        var entry = this.archive[i];
        var isInCurrentCategory = true;
        if (this.currentCategory) {
          isInCurrentCategory = this.entryInCurrentCategory(entry);
        }
        if (isInCurrentCategory && !entry.noDetails) {
          this.showEntry(entry);
          break;
        }
        if (i === 0) {
          i = this.archive.length;
        }
      }
    },
    entryInFilter: function entryInFilter(entry) {
      if (!this.filterText) {
        return false;
      }
      return entry.title.toLowerCase().indexOf(this.filterText.toLowerCase()) !== -1;
    },
    entryInCurrentCategory: function entryInCurrentCategory(entry) {
      var _this3 = this;

      if (!this.currentCategory) {
        return false;
      }
      var cat = entry.categories.find(function (c) {
        return c.id === _this3.currentCategory.id;
      });
      if (!cat) {
        return false;
      }
      return true;
    },
    setPageWidthProperty: function setPageWidthProperty() {
      this.pageWidth = window.innerWidth;
    }
  },
  mounted: function mounted() {
    this.loadArchive();
    this.setPageWidthProperty();
    window.addEventListener('resize', this.setPageWidthProperty);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.setPageWidthProperty);
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    on: {
      "click": function($event) {
        _vm.showCategorySelection = false
      }
    }
  }, [_c('div', {
    staticClass: "menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("bioplan architekten")])], 1)]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    staticClass: "active",
    attrs: {
      "to": {
        name: 'Archive'
      }
    }
  }, [_vm._v("archiv")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Office'
      }
    }
  }, [_vm._v("büro")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Contact'
      }
    }
  }, [_vm._v("contact")])], 1)]), _vm._v(" "), (!_vm.currentEntry) ? _c('div', {
    staticClass: "search",
    attrs: {
      "role": "search"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterText),
      expression: "filterText"
    }],
    attrs: {
      "placeholder": "suche"
    },
    domProps: {
      "value": (_vm.filterText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterText = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.categories) ? _c('div', {
    staticClass: "categories",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(!_vm.showCategorySelection) ? _c('div', {
    on: {
      "click": function($event) {
        _vm.showCategorySelection = true
      }
    }
  }, [(_vm.currentCategory) ? _c('span', {
    style: ({
      color: _vm.currentCategory.color
    })
  }, [_vm._v("\n          " + _vm._s(_vm.currentCategory.name) + "\n        ")]) : [_vm._v("\n          alle kategorien\n        ")], _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin": "0",
      "padding": "0"
    }
  }, [_vm._v("v")])], 2) : _c('div', {
    staticClass: "category-list"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.currentCategory = null;
        _vm.showCategorySelection = false
      },
      "mouseover": function($event) {
        _vm.currentCategory = null
      }
    }
  }, [_vm._v("alle Kategorien")])]), _vm._v(" "), _vm._l((_vm.categories), function(c) {
    return _c('li', [_c('a', {
      style: ({
        color: (c === _vm.currentCategory) ? _vm.currentCategory.color : 'white'
      }),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.currentCategory = c;
          _vm.showCategorySelection = false
        },
        "mouseover": function($event) {
          _vm.currentCategory = c
        }
      }
    }, [_vm._v(_vm._s(c.name))])])
  })], 2)])]) : _vm._e()]), _vm._v(" "), (_vm.currentEntry) ? [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left font-regular"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.currentEntry.title) + "\n        ")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.markedEntryText)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    class: ("image-container " + _vm.imageLayoutOption)
  }, [(_vm.imageLayoutOption == 'layout-large-only' || _vm.imageLayoutOption == 'layout-medium-only' || _vm.imageLayoutOption == 'layout-small-only' || _vm.imageLayoutOption == 'layout-large-small' || _vm.imageLayoutOption == 'layout-large-medium') ? _vm._l((_vm.currentEntryImagesSorted), function(img) {
    return _c('img', {
      class: {
        'img-large': img.originalWidth >= 800, 'img-medium': img.originalWidth < 800 && img.originalWidth >= 550, 'img-small': img.originalWidth < 550
      },
      attrs: {
        "src": img.url
      }
    })
  }) : [_vm._l((_vm.currentEntryImagesLarge), function(img) {
    return _c('img', {
      staticClass: "img-large",
      attrs: {
        "src": img.url
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, _vm._l((_vm.currentEntryImagesMedium), function(img) {
    return _c('img', {
      staticClass: "img-medium",
      attrs: {
        "src": img.url
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }, _vm._l((_vm.currentEntryImagesSmall), function(img) {
    return _c('img', {
      staticClass: "img-small",
      attrs: {
        "src": img.url
      }
    })
  }))]], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "move-left",
    on: {
      "mouseup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "left", 37)) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        $event.stopPropagation();
        _vm.movePreviousEntry($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "move-right",
    on: {
      "mouseup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "left", 37)) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        $event.stopPropagation();
        _vm.moveNextEntry($event)
      }
    }
  })] : [(_vm.archiveLoading) ? _c('LoadingSpinner') : [_c('div', {
    staticClass: "archive-columns"
  }, _vm._l((_vm.columns), function(column) {
    return _c('div', {
      staticClass: "archive-column"
    }, [_vm._l((column), function(a) {
      return [(a.noDetails) ? [_c('div', {
        class: {
          'flex-item': true, 'in-filter': _vm.entryInFilter(a), 'no-details': a.noDetails
        },
        style: ({
          color: (_vm.entryInCurrentCategory(a)) ? _vm.currentCategory.color : 'inherit'
        })
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v("\n                  " + _vm._s(a.title) + "\n                ")]), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_vm._v("\n                  " + _vm._s(_vm._f("toMonthYearString")(a.date)) + "\n                ")]), _vm._v(" "), _c('div', {
        staticClass: "strikethrough",
        style: ({
          background: (_vm.entryInCurrentCategory(a)) ? _vm.currentCategory.color : (_vm.entryInFilter(a) ? 'red' : 'white')
        })
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })])] : [_c('router-link', {
        class: {
          'flex-item': true, 'in-filter': _vm.entryInFilter(a), 'no-details': a.noDetails
        },
        style: ({
          color: (_vm.entryInCurrentCategory(a)) ? _vm.currentCategory.color : 'inherit'
        }),
        attrs: {
          "to": {
            name: 'ArchiveEntry',
            params: {
              id: a.id
            }
          },
          "tag": "div"
        }
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v("\n                  " + _vm._s(a.title) + "\n                ")]), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_vm._v("\n                  " + _vm._s(_vm._f("toMonthYearString")(a.date)) + "\n                ")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })])]]
    })], 2)
  }))]], _vm._v(" "), _vm._m(0)], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "information"
  }, [_c('img', {
    staticClass: "signet",
    attrs: {
      "src": __webpack_require__(6),
      "height": "57",
      "width": "72"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4339ed83_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(176);
function injectStyle (ssrContext) {
  __webpack_require__(174)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4339ed83"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4339ed83_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_rest__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_marked__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Contact',
  components: {
    LoadingSpinner: __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: false,
      text: ''
    };
  },

  computed: {
    textHtml: function textHtml() {
      return __WEBPACK_IMPORTED_MODULE_2_marked___default()(this.text, { sanitize: true, breaks: true });
    }
  },
  methods: {
    loadText: function loadText() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].pages.byName('contact', function (response, hasError) {
        if (hasError) {
          _this.isLoading = false;
          return;
        }
        _this.text = response.body.content;
        _this.isLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.loadText();
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("bioplan architekten")])], 1)]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Archive'
      }
    }
  }, [_vm._v("archiv")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Office'
      }
    }
  }, [_vm._v("büro")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "active",
    attrs: {
      "to": {
        name: 'Contact'
      }
    }
  }, [_vm._v("contact")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.isLoading) ? _c('LoadingSpinner') : [_c('div', {
    staticClass: "left font-regular",
    domProps: {
      "innerHTML": _vm._s(_vm.textHtml)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('iframe', {
    staticClass: "map",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "src": "https://snazzymaps.com/embed/6656",
      "width": "100%",
      "height": "600px"
    }
  })])]], 2), _vm._v(" "), _vm._m(0)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "information"
  }, [_c('img', {
    staticClass: "signet",
    attrs: {
      "src": __webpack_require__(6),
      "height": "57",
      "width": "72"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Office_vue__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b630f1ae_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Office_vue__ = __webpack_require__(180);
function injectStyle (ssrContext) {
  __webpack_require__(178)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b630f1ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Office_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b630f1ae_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Office_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_rest__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_marked__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Office',
  components: {
    LoadingSpinner: __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__["a" /* default */]
  },
  data: function data() {
    return {
      people: [],
      loadingPeople: true,
      loadingText: true,
      text: ''
    };
  },

  computed: {
    isLoading: function isLoading() {
      return this.loadingPeople || this.loadingText;
    },
    textHtml: function textHtml() {
      return __WEBPACK_IMPORTED_MODULE_2_marked___default()(this.text, { sanitize: true, breaks: true });
    }
  },
  methods: {
    loadPeople: function loadPeople() {
      var _this = this;

      this.loadingPeople = true;

      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].persons.all(function (response, hasError) {
        if (hasError) {
          return;
        }
        _this.people = response.data;
        _this.loadingPeople = false;
      });
    },
    loadText: function loadText() {
      var _this2 = this;

      this.loadingText = true;
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].pages.byName('office', function (response, hasError) {
        if (hasError) {
          _this2.loadingText = false;
          return;
        }
        _this2.text = response.body.content;
        _this2.loadingText = false;
      });
    }
  },
  mounted: function mounted() {
    this.loadPeople();
    this.loadText();
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("bioplan architekten")])], 1)]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Archive'
      }
    }
  }, [_vm._v("archiv")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "active",
    attrs: {
      "to": {
        name: 'Office'
      }
    }
  }, [_vm._v("büro")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Contact'
      }
    }
  }, [_vm._v("contact")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.isLoading) ? _c('LoadingSpinner') : [_c('div', {
    staticClass: "left font-regular",
    domProps: {
      "innerHTML": _vm._s(_vm.textHtml)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [(!_vm.loadingPeople) ? _c('div', {
    staticClass: "img-container"
  }, _vm._l((_vm.people), function(p) {
    return _c('div', {
      staticClass: "person",
      style: (("color: " + (p.color)))
    }, [_c('img', {
      attrs: {
        "src": p.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name font-medium"
    }, [_vm._v("\n              " + _vm._s(p.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n              " + _vm._s(p.title) + "\n            ")])])
  })) : _vm._e()])]], 2), _vm._v(" "), _vm._m(0)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "information"
  }, [_c('img', {
    staticClass: "signet",
    attrs: {
      "src": __webpack_require__(6),
      "height": "57",
      "width": "72"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminMain_vue__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e71014b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AdminMain_vue__ = __webpack_require__(210);
function injectStyle (ssrContext) {
  __webpack_require__(182)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e71014b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AdminMain_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminMain',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    isLoggedIn: 'auth/isLoggedIn',
    userData: 'auth/userData'
  })),
  methods: {
    logout: function logout() {
      this.$store.commit('auth/LOGOUT');
      this.$router.push({ name: 'Login' });
    }
  }
});

/***/ }),
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container admin"
  }, [_c('div', {
    staticClass: "menu menu-admin",
    attrs: {
      "role": "menu"
    }
  }, [_vm._v("\n    bioplan architekten"), (_vm.isLoggedIn && _vm.userData) ? [_vm._v(" - " + _vm._s(_vm.userData.username) + " - "), _c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])] : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.isLoggedIn) ? _c('ul', [_c('li', [_c('router-link', {
    class: {
      active: _vm.$route.name == 'AdminUsers'
    },
    attrs: {
      "to": {
        name: 'AdminUsers'
      }
    }
  }, [_vm._v("Benutzer")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      active: _vm.$route.name == 'AdminSlides'
    },
    attrs: {
      "to": {
        name: 'AdminSlides'
      }
    }
  }, [_vm._v("Slides")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      active: _vm.$route.name == 'AdminPersons'
    },
    attrs: {
      "to": {
        name: 'AdminPersons'
      }
    }
  }, [_vm._v("Personen")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      active: _vm.$route.name == 'AdminCategories'
    },
    attrs: {
      "to": {
        name: 'AdminCategories'
      }
    }
  }, [_vm._v("Kategorien")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      active: _vm.$route.name == 'AdminEntries'
    },
    attrs: {
      "to": {
        name: 'AdminEntries'
      }
    }
  }, [_vm._v("Einträge")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      active: _vm.$route.name == 'AdminPages'
    },
    attrs: {
      "to": {
        name: 'AdminPages'
      }
    }
  }, [_vm._v("Seiten")])], 1)]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_caf3afe8_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(214);
function injectStyle (ssrContext) {
  __webpack_require__(212)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-caf3afe8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_caf3afe8_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_rest__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  components: {
    LoadingSpinner: __WEBPACK_IMPORTED_MODULE_2__parts_LoadingSpinner__["a" /* default */]
  },
  data: function data() {
    return {
      username: '',
      password: '',
      loginErrorMessage: '',
      isLoggingIn: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    isLoggedIn: 'auth/isLoggedIn'
  })),
  methods: {
    login: function login() {
      var _this = this;

      this.loginErrorMessage = '';
      if (!this.username || !this.password) {
        this.loginErrorMessage = 'Bitte geben Sie Benutzernamen und Passwort an.';
        return;
      }

      this.isLoggingIn = true;
      __WEBPACK_IMPORTED_MODULE_3__services_rest__["a" /* default */].auth.login(this.username, this.password, function (response, hasError) {
        if (hasError) {
          _this.loginErrorMessage = 'Beim Login ist ein Fehler aufgetreten. Bitte prüfen Sie Benutzernamen und Passwort.';
          _this.isLoggingIn = false;
          return;
        }

        _this.$store.commit('auth/LOGIN', response.body);
        _this.$router.push({ name: 'AdminSlides' });
        _this.isLoggingIn = false;
      });
    }
  },
  mounted: function mounted() {
    if (this.isLoggedIn) {
      this.$router.push({ name: 'AdminSlides' });
    }
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Benutzername",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Passwort"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isLoggingIn
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('div', {
    staticClass: "login-error"
  }, [_vm._v(_vm._s(_vm.loginErrorMessage))]), _vm._v(" "), (_vm.isLoggingIn) ? _c('LoadingSpinner') : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminSlides_vue__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_891d7d18_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSlides_vue__ = __webpack_require__(218);
function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-891d7d18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminSlides_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_891d7d18_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSlides_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_rest__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminSlides',
  components: {
    LoadingSpinner: __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: true,
      items: [],
      selectedItem: null
    };
  },

  methods: {
    loadItems: function loadItems() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].slides.all(function (response, hasError) {
        if (hasError) {
          return;
        }
        _this.items = response.body;
        _this.isLoading = false;
      });
    },
    deleteItem: function deleteItem(item) {
      var _this2 = this;

      if (!confirm('Wollen Sie das wirklich löschen?')) {
        return;
      }
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].slides.delete(item.id, function (response, hasError) {
        if (!hasError) {
          var index = _this2.items.indexOf(item);
          if (index > -1) {
            _this2.items.splice(index, 1);
          }
        }
        _this2.isLoading = false;
      });
    },
    addItem: function addItem() {
      var newItem = {
        id: 0,
        title: '',
        description: '',
        url: ''
      };
      this.selectedItem = newItem;
    },
    saveItem: function saveItem() {
      var _this3 = this;

      this.isLoading = true;
      var files = this.$refs.uploadFile.files;
      var file = null;
      if (!files || files.length !== 1) {
        if (this.selectedItem.id === 0) {
          this.isLoading = false;
          return;
        }
      } else {
        file = files[0];
      }
      if (this.selectedItem.id > 0) {
        __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].slides.update(this.selectedItem, file, function (response, hasError) {
          if (hasError) {
            _this3.isLoading = false;
            return;
          }
          var newItem = response.body;
          var index = _this3.items.indexOf(_this3.selectedItem);
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(_this3.items, index, newItem);
          _this3.selectedItem = null;
          _this3.isLoading = false;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].slides.add(this.selectedItem, file, function (response, hasError) {
          if (hasError) {
            _this3.isLoading = false;
            return;
          }
          var newItem = response.body;
          _this3.items.push(newItem);
          _this3.selectedItem = null;
          _this3.isLoading = false;
        });
      }
    }
  },
  mounted: function mounted() {
    this.loadItems();
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Slides")]), _vm._v(" "), (_vm.selectedItem && _vm.selectedItem.id > 0) ? _c('h2', [_vm._v("Bearbeiten")]) : (_vm.selectedItem && _vm.selectedItem.id == 0) ? _c('h2', [_vm._v("Neu")]) : _vm._e(), _vm._v(" "), (!_vm.selectedItem) ? _c('button', {
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("Neu")]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('LoadingSpinner') : [(!_vm.selectedItem) ? [(_vm.items && _vm.items.length > 0) ? _c('table', {
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("Titel")]), _vm._v(" "), _c('th', [_vm._v("Beschreibung")]), _vm._v(" "), _c('th', [_vm._v("Bild")]), _vm._v(" "), _c('th', [_vm._v("Aktionen")])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n            " + _vm._s(item.title) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.description) + "\n          ")]), _vm._v(" "), _c('td', [(item.url) ? _c('img', {
      staticStyle: {
        "max-width": "100px"
      },
      attrs: {
        "src": item.url
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          _vm.deleteItem(item)
        }
      }
    }, [_vm._v("Löschen")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.selectedItem = item
        }
      }
    }, [_vm._v("Bearbeiten")])])])
  })], 2) : [_vm._v("\n        Keine Daten gefunden\n      ")]] : [_c('div', {
    staticClass: "edit-form"
  }, [_c('label', [_vm._v("Titel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.title),
      expression: "selectedItem.title"
    }],
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.selectedItem.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedItem.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("Beschreibung")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.description),
      expression: "selectedItem.description"
    }],
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.selectedItem.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedItem.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("Bild")]), _vm._v(" "), _c('input', {
    ref: "uploadFile",
    attrs: {
      "type": "file",
      "name": "uploadFile",
      "id": "uploadFile",
      "accept": "image/*"
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.saveItem
    }
  }, [_vm._v("Speichern")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.selectedItem = null
      }
    }
  }, [_vm._v("Abbrechen")])]]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminPersons_vue__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c27c08c8_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AdminPersons_vue__ = __webpack_require__(222);
function injectStyle (ssrContext) {
  __webpack_require__(220)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c27c08c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminPersons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c27c08c8_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AdminPersons_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_rest__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_color__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_color__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminPersons',
  components: {
    LoadingSpinner: __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__["a" /* default */],
    'chrome-picker': __WEBPACK_IMPORTED_MODULE_3_vue_color__["Chrome"]
  },
  data: function data() {
    return {
      isLoading: true,
      items: [],
      selectedItem: null
    };
  },

  methods: {
    loadItems: function loadItems() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].persons.all(function (response, hasError) {
        if (hasError) {
          return;
        }
        _this.items = response.body;
        _this.isLoading = false;
      });
    },
    deleteItem: function deleteItem(item) {
      var _this2 = this;

      if (!confirm('Wollen Sie das wirklich löschen?')) {
        return;
      }
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].persons.delete(item.id, function (response, hasError) {
        if (!hasError) {
          var index = _this2.items.indexOf(item);
          if (index > -1) {
            _this2.items.splice(index, 1);
          }
        }
        _this2.isLoading = false;
      });
    },
    addItem: function addItem() {
      var newItem = {
        id: 0,
        name: '',
        title: '',
        url: '',
        color: '#ff0000'
      };
      this.selectedItem = newItem;
    },
    saveItem: function saveItem() {
      var _this3 = this;

      this.isLoading = true;
      var files = this.$refs.uploadFile.files;
      var file = null;
      if (!files || files.length !== 1) {
        if (this.selectedItem.id === 0) {
          this.isLoading = false;
          return;
        }
      } else {
        file = files[0];
      }
      if (this.selectedItem.id > 0) {
        __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].persons.update(this.selectedItem, file, function (response, hasError) {
          if (hasError) {
            _this3.isLoading = false;
            return;
          }
          var newItem = response.body;
          var index = _this3.items.indexOf(_this3.selectedItem);
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(_this3.items, index, newItem);
          _this3.selectedItem = null;
          _this3.isLoading = false;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].persons.add(this.selectedItem, file, function (response, hasError) {
          if (hasError) {
            _this3.isLoading = false;
            return;
          }
          var newItem = response.body;
          _this3.items.push(newItem);
          _this3.selectedItem = null;
          _this3.isLoading = false;
        });
      }
    }
  },
  mounted: function mounted() {
    this.loadItems();
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Personen")]), _vm._v(" "), (_vm.selectedItem && _vm.selectedItem.id > 0) ? _c('h2', [_vm._v("Bearbeiten")]) : (_vm.selectedItem && _vm.selectedItem.id == 0) ? _c('h2', [_vm._v("Neu")]) : _vm._e(), _vm._v(" "), (!_vm.selectedItem) ? _c('button', {
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("Neu")]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('LoadingSpinner') : [(!_vm.selectedItem) ? [(_vm.items && _vm.items.length > 0) ? _c('table', {
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Titel")]), _vm._v(" "), _c('th', [_vm._v("Farbe")]), _vm._v(" "), _c('th', [_vm._v("Bild")]), _vm._v(" "), _c('th', [_vm._v("Aktionen")])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.title) + "\n          ")]), _vm._v(" "), _c('td', {
      style: (("color: " + (item.color)))
    }, [_vm._v("\n            " + _vm._s(item.color) + "\n          ")]), _vm._v(" "), _c('td', [(item.url) ? _c('img', {
      staticStyle: {
        "max-width": "100px"
      },
      attrs: {
        "src": item.url
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          _vm.deleteItem(item)
        }
      }
    }, [_vm._v("Löschen")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.selectedItem = item
        }
      }
    }, [_vm._v("Bearbeiten")])])])
  })], 2) : [_vm._v("\n        Keine Daten gefunden\n      ")]] : [_c('div', {
    staticClass: "edit-form"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.name),
      expression: "selectedItem.name"
    }],
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.selectedItem.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedItem.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("Titel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.title),
      expression: "selectedItem.title"
    }],
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.selectedItem.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedItem.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("Bild")]), _vm._v(" "), _c('input', {
    ref: "uploadFile",
    attrs: {
      "type": "file",
      "name": "uploadFile",
      "id": "uploadFile",
      "accept": "image/*"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("Farbe")]), _vm._v(" "), _c('chrome-picker', {
    attrs: {
      "value": {
        hex: _vm.selectedItem.color
      }
    },
    on: {
      "input": function (val) { return _vm.selectedItem.color = val.hex; }
    }
  })], 1), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.saveItem
    }
  }, [_vm._v("Speichern")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.selectedItem = null
      }
    }
  }, [_vm._v("Abbrechen")])]]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminCategories_vue__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2682d4ae_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AdminCategories_vue__ = __webpack_require__(226);
function injectStyle (ssrContext) {
  __webpack_require__(224)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2682d4ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2682d4ae_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AdminCategories_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_rest__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_color__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_color__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminCategories',
  components: {
    LoadingSpinner: __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__["a" /* default */],
    'chrome-picker': __WEBPACK_IMPORTED_MODULE_3_vue_color__["Chrome"]
  },
  data: function data() {
    return {
      isLoading: true,
      items: [],
      selectedItem: null
    };
  },

  methods: {
    loadItems: function loadItems() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].categories.all(function (response, hasError) {
        if (hasError) {
          return;
        }
        _this.items = response.body;
        _this.isLoading = false;
      });
    },
    deleteItem: function deleteItem(item) {
      var _this2 = this;

      if (!confirm('Wollen Sie das wirklich löschen?')) {
        return;
      }
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].categories.delete(item.id, function (response, hasError) {
        if (!hasError) {
          var index = _this2.items.indexOf(item);
          if (index > -1) {
            _this2.items.splice(index, 1);
          }
        }
        _this2.isLoading = false;
      });
    },
    addItem: function addItem() {
      var newItem = {
        id: 0,
        name: '',
        color: '#ff0000'
      };
      this.selectedItem = newItem;
    },
    saveItem: function saveItem() {
      var _this3 = this;

      this.isLoading = true;
      if (this.selectedItem.id > 0) {
        __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].categories.update(this.selectedItem, function (response, hasError) {
          if (hasError) {
            _this3.isLoading = false;
            return;
          }
          var newItem = response.body;
          var index = _this3.items.indexOf(_this3.selectedItem);
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(_this3.items, index, newItem);
          _this3.selectedItem = null;
          _this3.isLoading = false;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].categories.add(this.selectedItem, function (response, hasError) {
          if (hasError) {
            _this3.isLoading = false;
            return;
          }
          var newItem = response.body;
          _this3.items.push(newItem);
          _this3.selectedItem = null;
          _this3.isLoading = false;
        });
      }
    }
  },
  mounted: function mounted() {
    this.loadItems();
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Kategorien")]), _vm._v(" "), (_vm.selectedItem && _vm.selectedItem.id > 0) ? _c('h2', [_vm._v("Bearbeiten")]) : (_vm.selectedItem && _vm.selectedItem.id == 0) ? _c('h2', [_vm._v("Neu")]) : _vm._e(), _vm._v(" "), (!_vm.selectedItem) ? _c('button', {
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("Neu")]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('LoadingSpinner') : [(!_vm.selectedItem) ? [(_vm.items && _vm.items.length > 0) ? _c('table', {
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Farbe")]), _vm._v(" "), _c('th', [_vm._v("Aktionen")])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), _c('td', {
      style: (("color: " + (item.color)))
    }, [_vm._v("\n            " + _vm._s(item.color) + "\n          ")]), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          _vm.deleteItem(item)
        }
      }
    }, [_vm._v("Löschen")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.selectedItem = item
        }
      }
    }, [_vm._v("Bearbeiten")])])])
  })], 2) : [_vm._v("\n        Keine Daten gefunden\n      ")]] : [_c('div', {
    staticClass: "edit-form"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.name),
      expression: "selectedItem.name"
    }],
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.selectedItem.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedItem.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("Farbe")]), _vm._v(" "), _c('chrome-picker', {
    attrs: {
      "value": {
        hex: _vm.selectedItem.color
      }
    },
    on: {
      "input": function (val) { return _vm.selectedItem.color = val.hex; }
    }
  })], 1), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.saveItem
    }
  }, [_vm._v("Speichern")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.selectedItem = null
      }
    }
  }, [_vm._v("Abbrechen")])]]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUsers_vue__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72e44334_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUsers_vue__ = __webpack_require__(230);
function injectStyle (ssrContext) {
  __webpack_require__(228)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72e44334"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72e44334_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUsers_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_rest__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminUsers',
  components: {
    LoadingSpinner: __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: true,
      items: [],
      selectedItem: null
    };
  },

  methods: {
    loadItems: function loadItems() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].users.all(function (response, hasError) {
        if (hasError) {
          return;
        }
        _this.items = response.body;
        _this.isLoading = false;
      });
    },
    deleteItem: function deleteItem(item) {
      var _this2 = this;

      if (!confirm('Wollen Sie das wirklich löschen?')) {
        return;
      }
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].users.delete(item.id, function (response, hasError) {
        if (!hasError) {
          var index = _this2.items.indexOf(item);
          if (index > -1) {
            _this2.items.splice(index, 1);
          }
        }
        _this2.isLoading = false;
      });
    },
    addItem: function addItem() {
      var newItem = {
        id: 0,
        username: '',
        password: ''
      };
      this.selectedItem = newItem;
    },
    saveItem: function saveItem() {
      var _this3 = this;

      this.isLoading = true;
      if (this.selectedItem.id > 0) {
        __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].users.update(this.selectedItem, function (response, hasError) {
          if (hasError) {
            _this3.isLoading = false;
            return;
          }
          var newItem = response.body;
          var index = _this3.items.indexOf(_this3.selectedItem);
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(_this3.items, index, newItem);
          _this3.selectedItem = null;
          _this3.isLoading = false;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].users.add(this.selectedItem, function (response, hasError) {
          if (hasError) {
            _this3.isLoading = false;
            return;
          }
          var newItem = response.body;
          _this3.items.push(newItem);
          _this3.selectedItem = null;
          _this3.isLoading = false;
        });
      }
    }
  },
  mounted: function mounted() {
    this.loadItems();
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Benutzer")]), _vm._v(" "), (_vm.selectedItem && _vm.selectedItem.id > 0) ? _c('h2', [_vm._v("Bearbeiten")]) : (_vm.selectedItem && _vm.selectedItem.id == 0) ? _c('h2', [_vm._v("Neu")]) : _vm._e(), _vm._v(" "), (!_vm.selectedItem) ? _c('button', {
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("Neu")]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('LoadingSpinner') : [(!_vm.selectedItem) ? [(_vm.items && _vm.items.length > 0) ? _c('table', {
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Aktionen")])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n            " + _vm._s(item.username) + "\n          ")]), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          _vm.deleteItem(item)
        }
      }
    }, [_vm._v("Löschen")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.selectedItem = item
        }
      }
    }, [_vm._v("Bearbeiten")])])])
  })], 2) : [_vm._v("\n        Keine Daten gefunden\n      ")]] : [_c('div', {
    staticClass: "edit-form"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.username),
      expression: "selectedItem.username"
    }],
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.selectedItem.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedItem.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("Passwort")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.password),
      expression: "selectedItem.password"
    }],
    attrs: {
      "type": "password",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.selectedItem.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedItem.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.saveItem
    }
  }, [_vm._v("Speichern")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.selectedItem = null
      }
    }
  }, [_vm._v("Abbrechen")])]]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminEntries_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4369f76e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AdminEntries_vue__ = __webpack_require__(236);
function injectStyle (ssrContext) {
  __webpack_require__(232)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4369f76e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminEntries_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4369f76e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AdminEntries_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_rest__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminEntries',
  components: {
    LoadingSpinner: __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a
  },
  data: function data() {
    return {
      isLoadingItems: true,
      items: [],
      selectedItem: null,
      isLoadingCategories: true,
      categories: [],
      selectedCategories: [],
      imgEditItem: null,
      smallImages: [],
      mediumImages: [],
      largeImages: []
    };
  },

  computed: {
    isLoading: function isLoading() {
      return this.isLoadingItems || this.isLoadingCategories;
    }
  },
  watch: {
    selectedItem: function selectedItem() {
      var item = this.selectedItem;
      this.categories.forEach(function (cat) {
        if (item) {
          var foundCategory = item.categories.find(function (c) {
            return c.id === cat.id;
          });
          var isSelected = item.id > 0 && foundCategory;
          cat.selected = isSelected;
        } else {
          cat.selected = false;
        }
      });
    },
    imgEditItem: function imgEditItem() {
      if (!this.imgEditItem || !this.imgEditItem.images) {
        this.smallImages = [];
        this.mediumImages = [];
        this.largeImages = [];
        return;
      }
      this.smallImages = this.imgEditItem.images.filter(function (img) {
        return img.size === null || img.size === 0;
      });
      this.smallImages = this.smallImages.sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      });
      this.mediumImages = this.imgEditItem.images.filter(function (img) {
        return img.size === 1;
      });
      this.mediumImages = this.mediumImages.sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      });
      this.largeImages = this.imgEditItem.images.filter(function (img) {
        return img.size === 2;
      });
      this.largeImages = this.largeImages.sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      });
    }
  },
  methods: {
    loadItems: function loadItems() {
      var _this = this;

      this.isLoadingItems = true;
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].entries.all(function (response, hasError) {
        if (hasError) {
          return;
        }
        _this.items = response.body;
        _this.isLoadingItems = false;
      });
    },
    loadCategories: function loadCategories() {
      var _this2 = this;

      this.isLoadingCategories = true;
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].categories.all(function (response, hasError) {
        if (hasError) {
          return;
        }
        var categories = response.body;
        categories.forEach(function (cat) {
          cat.selected = false;
        });
        _this2.categories = categories;
        _this2.isLoadingCategories = false;
      });
    },
    deleteItem: function deleteItem(item) {
      var _this3 = this;

      if (!confirm('Wollen Sie das wirklich löschen?')) {
        return;
      }
      this.isLoadingItems = true;
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].entries.delete(item.id, function (response, hasError) {
        if (!hasError) {
          var index = _this3.items.indexOf(item);
          if (index > -1) {
            _this3.items.splice(index, 1);
          }
        }
        _this3.isLoadingItems = false;
      });
    },
    addItem: function addItem() {
      var newItem = {
        id: 0,
        title: '',
        text: '',
        categories: [],
        noDetails: false,
        date: new Date().getFullYear() + '-01-01'
      };
      this.selectedItem = newItem;
    },
    saveItem: function saveItem() {
      var _this4 = this;

      this.isLoadingItems = true;

      this.selectedItem.categories = [];
      this.categories.forEach(function (cat) {
        if (cat.selected) {
          _this4.selectedItem.categories.push(cat);
        }
      });

      if (this.selectedItem.id > 0) {
        __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].entries.update(this.selectedItem, function (response, hasError) {
          if (hasError) {
            _this4.isLoadingItems = false;
            return;
          }
          var newItem = response.body;
          var index = _this4.items.indexOf(_this4.selectedItem);
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(_this4.items, index, newItem);
          _this4.selectedItem = null;
          _this4.isLoadingItems = false;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].entries.add(this.selectedItem, function (response, hasError) {
          if (hasError) {
            _this4.isLoadingItems = false;
            return;
          }
          var newItem = response.body;
          _this4.items.push(newItem);
          _this4.selectedItem = null;
          _this4.isLoadingItems = false;
        });
      }
    },
    startImageUpload: function startImageUpload() {
      var _this5 = this;

      var files = this.$refs.uploadFiles.files;
      if (!files || files.length < 1) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].entries.addImage(this.imgEditItem.id, files, function (response, hasError) {
        if (hasError) {
          return;
        }
        var newItem = response.body;
        var index = _this5.items.indexOf(_this5.imgEditItem);
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(_this5.items, index, newItem);
        _this5.imgEditItem = newItem;
      });
    },
    removeImage: function removeImage(img) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].entries.removeImage(img.id, function (response, hasError) {
        if (hasError) {
          return;
        }
        var newItem = response.body;
        var index = _this6.items.indexOf(_this6.imgEditItem);
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(_this6.items, index, newItem);
        _this6.imgEditItem = newItem;
      });
    },
    saveImageSorting: function saveImageSorting() {
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].entries.saveImageMapping(this.smallImages, this.mediumImages, this.largeImages, function (response, hasError) {});
      var sortIndex = 0;
      this.smallImages.forEach(function (img) {
        img.size = 0;
        img.sortOrder = sortIndex;
        sortIndex++;
      });
      sortIndex = 0;
      this.mediumImages.forEach(function (img) {
        img.size = 1;
        img.sortOrder = sortIndex;
        sortIndex++;
      });
      this.largeImages.forEach(function (img) {
        img.size = 2;
        img.sortOrder = sortIndex;
        sortIndex++;
      });
    }
  },
  mounted: function mounted() {
    this.loadItems();
    this.loadCategories();
  }
});

/***/ }),
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Einträge")]), _vm._v(" "), (_vm.selectedItem && _vm.selectedItem.id > 0) ? _c('h2', [_vm._v("Bearbeiten")]) : (_vm.selectedItem && _vm.selectedItem.id == 0) ? _c('h2', [_vm._v("Neu")]) : _vm._e(), _vm._v(" "), (!_vm.selectedItem && !_vm.imgEditItem) ? _c('button', {
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("Neu")]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('LoadingSpinner') : [(!_vm.selectedItem && !_vm.imgEditItem) ? [(_vm.items && _vm.items.length > 0) ? _c('table', {
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("Titel")]), _vm._v(" "), _c('th', [_vm._v("Datum")]), _vm._v(" "), _c('th', [_vm._v("Keine Details?")]), _vm._v(" "), _c('th', [_vm._v("Kategorien")]), _vm._v(" "), _c('th', [_vm._v("Aktionen")])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n            " + _vm._s(item.title) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm._f("toDateString")(item.date)) + "\n          ")]), _vm._v(" "), _c('td', [(item.noDetails) ? [_vm._v("\n              Ja\n            ")] : [_vm._v("\n              Nein\n            ")]], 2), _vm._v(" "), _c('td', [_vm._l((item.categories), function(category, index) {
      return [_vm._v("\n              " + _vm._s(category.name)), (index + 1 < item.categories.length) ? [_vm._v(", ")] : _vm._e()]
    })], 2), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          _vm.deleteItem(item)
        }
      }
    }, [_vm._v("Löschen")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.selectedItem = item
        }
      }
    }, [_vm._v("Bearbeiten")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.imgEditItem = item
        }
      }
    }, [_vm._v("Bilder")])])])
  })], 2) : [_vm._v("\n        Keine Daten gefunden\n      ")]] : (!_vm.imgEditItem) ? [_c('div', {
    staticClass: "edit-form"
  }, [_c('label', [_vm._v("Titel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.title),
      expression: "selectedItem.title"
    }],
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.selectedItem.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedItem.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("Datum")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.date),
      expression: "selectedItem.date"
    }],
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.selectedItem.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedItem.date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n          Text"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "https://de.wikipedia.org/wiki/Markdown",
      "target": "_blank"
    }
  }, [_vm._v("(Markdown-Syntax)")])])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.text),
      expression: "selectedItem.text"
    }],
    domProps: {
      "value": (_vm.selectedItem.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedItem.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "noDetails"
    }
  }, [_vm._v("\n          Keine Details?\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.noDetails),
      expression: "selectedItem.noDetails"
    }],
    attrs: {
      "id": "noDetails",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectedItem.noDetails) ? _vm._i(_vm.selectedItem.noDetails, null) > -1 : (_vm.selectedItem.noDetails)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.selectedItem.noDetails,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectedItem.noDetails = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selectedItem.noDetails = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectedItem.noDetails = $$c
        }
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n          Kategorien\n        ")]), _vm._v(" "), (_vm.categories) ? _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, _vm._l((_vm.categories), function(cat) {
    return _c('div', {
      class: {
        category: true, 'category-selected': cat.selected
      },
      style: (("border-color: " + (cat.color))),
      on: {
        "click": function($event) {
          cat.selected = !cat.selected
        }
      }
    }, [_vm._v("\n            " + _vm._s(cat.name) + "\n          ")])
  })) : _vm._e()]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.saveItem
    }
  }, [_vm._v("Speichern")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.selectedItem = null
      }
    }
  }, [_vm._v("Abbrechen")])] : [_c('h2', [_vm._v("Bilder: " + _vm._s(_vm.imgEditItem.title))]), _vm._v("\n\n      Hinzufügen:\n      "), _c('input', {
    ref: "uploadFiles",
    attrs: {
      "type": "file",
      "name": "uploadFiles",
      "id": "uploadFiles",
      "accept": "image/*",
      "multiple": ""
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.startImageUpload
    }
  }, [_vm._v("Hochladen")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.imgEditItem = null
      }
    }
  }, [_vm._v("Zurück zu den Einträgen")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.saveImageSorting
    }
  }, [_vm._v("Bild-Zuordnung und -Sortierung speichern")]), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_vm._v("\n          Groß\n          "), _c('div', {
    staticClass: "image-list"
  }, [_c('draggable', {
    staticClass: "dragArea",
    attrs: {
      "options": {
        group: 'images'
      }
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.largeImages),
      callback: function($$v) {
        _vm.largeImages = $$v
      },
      expression: "largeImages"
    }
  }, _vm._l((_vm.largeImages), function(img) {
    return _c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "max-width": "120px",
        "max-height": "120px"
      },
      attrs: {
        "src": img.url
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.removeImage(img)
        }
      }
    }, [_vm._v("Löschen")])])])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "image-container"
  }, [_vm._v("\n          Mittel\n          "), _c('div', {
    staticClass: "image-list"
  }, [_c('draggable', {
    staticClass: "dragArea",
    attrs: {
      "options": {
        group: 'images'
      }
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.mediumImages),
      callback: function($$v) {
        _vm.mediumImages = $$v
      },
      expression: "mediumImages"
    }
  }, _vm._l((_vm.mediumImages), function(img) {
    return _c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "max-width": "120px",
        "max-height": "120px"
      },
      attrs: {
        "src": img.url
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.removeImage(img)
        }
      }
    }, [_vm._v("Löschen")])])])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "image-container"
  }, [_vm._v("\n          Klein\n          "), _c('div', {
    staticClass: "image-list"
  }, [_c('draggable', {
    staticClass: "dragArea",
    attrs: {
      "options": {
        group: 'images'
      }
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.smallImages),
      callback: function($$v) {
        _vm.smallImages = $$v
      },
      expression: "smallImages"
    }
  }, _vm._l((_vm.smallImages), function(img) {
    return _c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "max-width": "120px",
        "max-height": "120px"
      },
      attrs: {
        "src": img.url
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.removeImage(img)
        }
      }
    }, [_vm._v("Löschen")])])])
  }))], 1)])])]]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminPages_vue__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31fffbbc_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AdminPages_vue__ = __webpack_require__(240);
function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31fffbbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminPages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31fffbbc_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AdminPages_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_rest__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminPages',
  components: {
    LoadingSpinner: __WEBPACK_IMPORTED_MODULE_0__parts_LoadingSpinner__["a" /* default */]
  },
  data: function data() {
    return {
      isLoadingItems: true,
      items: [],
      selectedItem: null
    };
  },

  computed: {
    isLoading: function isLoading() {
      return this.isLoadingItems;
    }
  },
  methods: {
    loadItems: function loadItems() {
      var _this = this;

      this.isLoadingItems = true;
      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].pages.all(function (response, hasError) {
        if (hasError) {
          return;
        }
        _this.items = response.body;
        _this.isLoadingItems = false;
      });
    },
    saveItem: function saveItem() {
      var _this2 = this;

      this.isLoadingItems = true;

      __WEBPACK_IMPORTED_MODULE_1__services_rest__["a" /* default */].pages.update(this.selectedItem, function (response, hasError) {
        if (hasError) {
          _this2.isLoadingItems = false;
          return;
        }
        var newItem = response.body;
        var index = _this2.items.indexOf(_this2.selectedItem);
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(_this2.items, index, newItem);
        _this2.selectedItem = null;
        _this2.isLoadingItems = false;
      });
    }
  },
  mounted: function mounted() {
    this.loadItems();
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Seiten")]), _vm._v(" "), (_vm.selectedItem) ? _c('h2', [_vm._v("Bearbeiten: " + _vm._s(_vm.selectedItem.name))]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('LoadingSpinner') : [(!_vm.selectedItem) ? [(_vm.items && _vm.items.length > 0) ? _c('table', {
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Aktionen")])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          _vm.selectedItem = item
        }
      }
    }, [_vm._v("Bearbeiten")])])])
  })], 2) : [_vm._v("\n        Keine Daten gefunden\n      ")]] : [_c('div', {
    staticClass: "edit-form"
  }, [_c('label', [_vm._v("\n          Text"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "https://de.wikipedia.org/wiki/Markdown",
      "target": "_blank"
    }
  }, [_vm._v("(Markdown-Syntax)")])])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.content),
      expression: "selectedItem.content"
    }],
    domProps: {
      "value": (_vm.selectedItem.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedItem.content = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.saveItem
    }
  }, [_vm._v("Speichern")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.selectedItem = null
      }
    }
  }, [_vm._v("Abbrechen")])]]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth__ = __webpack_require__(242);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = false;

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth__["a" /* default */]
  },
  strict: debug
}));

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(250);


var _mutations;





var state = {
  token: ''
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* LOGIN */], function (state, data) {
  state.token = data;
  __WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* default */].setToken(data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* LOGOUT */], function (state) {
  state.token = null;
  __WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* default */].setToken(null);
}), _mutations);

var getters = {
  isLoggedIn: function isLoggedIn(state) {
    return state.token !== '' && state.token !== 'undefined' && state.token !== null;
  },
  userData: function userData(state) {
    if (!state.token) {
      return null;
    }
    var decoded = __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(state.token);
    if (!decoded) {
      return null;
    }
    var context = decoded.context;
    if (!context) {
      return null;
    }
    return {
      username: context.username
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters
});

/***/ }),
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGOUT; });
var LOGIN = 'LOGIN';
var LOGOUT = 'LOGOUT';

/***/ }),
/* 251 */,
/* 252 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 253 */,
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__todatestring__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__todatetimestring__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toFixedNumber__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toMonthYearString__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__newlineToBr__ = __webpack_require__(261);






/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('toDateString', function (original) {
  if (original !== null) {
    var retValue = __WEBPACK_IMPORTED_MODULE_1_moment___default()(original);
    retValue.locale('de');
    return retValue.format('L');
  }
  return original;
});

/***/ }),
/* 256 */,
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 24,
	"./af.js": 24,
	"./ar": 25,
	"./ar-dz": 26,
	"./ar-dz.js": 26,
	"./ar-kw": 27,
	"./ar-kw.js": 27,
	"./ar-ly": 28,
	"./ar-ly.js": 28,
	"./ar-ma": 29,
	"./ar-ma.js": 29,
	"./ar-sa": 30,
	"./ar-sa.js": 30,
	"./ar-tn": 31,
	"./ar-tn.js": 31,
	"./ar.js": 25,
	"./az": 32,
	"./az.js": 32,
	"./be": 33,
	"./be.js": 33,
	"./bg": 34,
	"./bg.js": 34,
	"./bn": 35,
	"./bn.js": 35,
	"./bo": 36,
	"./bo.js": 36,
	"./br": 37,
	"./br.js": 37,
	"./bs": 38,
	"./bs.js": 38,
	"./ca": 39,
	"./ca.js": 39,
	"./cs": 40,
	"./cs.js": 40,
	"./cv": 41,
	"./cv.js": 41,
	"./cy": 42,
	"./cy.js": 42,
	"./da": 43,
	"./da.js": 43,
	"./de": 44,
	"./de-at": 45,
	"./de-at.js": 45,
	"./de-ch": 46,
	"./de-ch.js": 46,
	"./de.js": 44,
	"./dv": 47,
	"./dv.js": 47,
	"./el": 48,
	"./el.js": 48,
	"./en-au": 49,
	"./en-au.js": 49,
	"./en-ca": 50,
	"./en-ca.js": 50,
	"./en-gb": 51,
	"./en-gb.js": 51,
	"./en-ie": 52,
	"./en-ie.js": 52,
	"./en-nz": 53,
	"./en-nz.js": 53,
	"./eo": 54,
	"./eo.js": 54,
	"./es": 55,
	"./es-do": 56,
	"./es-do.js": 56,
	"./es.js": 55,
	"./et": 57,
	"./et.js": 57,
	"./eu": 58,
	"./eu.js": 58,
	"./fa": 59,
	"./fa.js": 59,
	"./fi": 60,
	"./fi.js": 60,
	"./fo": 61,
	"./fo.js": 61,
	"./fr": 62,
	"./fr-ca": 63,
	"./fr-ca.js": 63,
	"./fr-ch": 64,
	"./fr-ch.js": 64,
	"./fr.js": 62,
	"./fy": 65,
	"./fy.js": 65,
	"./gd": 66,
	"./gd.js": 66,
	"./gl": 67,
	"./gl.js": 67,
	"./gom-latn": 68,
	"./gom-latn.js": 68,
	"./he": 69,
	"./he.js": 69,
	"./hi": 70,
	"./hi.js": 70,
	"./hr": 71,
	"./hr.js": 71,
	"./hu": 72,
	"./hu.js": 72,
	"./hy-am": 73,
	"./hy-am.js": 73,
	"./id": 74,
	"./id.js": 74,
	"./is": 75,
	"./is.js": 75,
	"./it": 76,
	"./it.js": 76,
	"./ja": 77,
	"./ja.js": 77,
	"./jv": 78,
	"./jv.js": 78,
	"./ka": 79,
	"./ka.js": 79,
	"./kk": 80,
	"./kk.js": 80,
	"./km": 81,
	"./km.js": 81,
	"./kn": 82,
	"./kn.js": 82,
	"./ko": 83,
	"./ko.js": 83,
	"./ky": 84,
	"./ky.js": 84,
	"./lb": 85,
	"./lb.js": 85,
	"./lo": 86,
	"./lo.js": 86,
	"./lt": 87,
	"./lt.js": 87,
	"./lv": 88,
	"./lv.js": 88,
	"./me": 89,
	"./me.js": 89,
	"./mi": 90,
	"./mi.js": 90,
	"./mk": 91,
	"./mk.js": 91,
	"./ml": 92,
	"./ml.js": 92,
	"./mr": 93,
	"./mr.js": 93,
	"./ms": 94,
	"./ms-my": 95,
	"./ms-my.js": 95,
	"./ms.js": 94,
	"./my": 96,
	"./my.js": 96,
	"./nb": 97,
	"./nb.js": 97,
	"./ne": 98,
	"./ne.js": 98,
	"./nl": 99,
	"./nl-be": 100,
	"./nl-be.js": 100,
	"./nl.js": 99,
	"./nn": 101,
	"./nn.js": 101,
	"./pa-in": 102,
	"./pa-in.js": 102,
	"./pl": 103,
	"./pl.js": 103,
	"./pt": 104,
	"./pt-br": 105,
	"./pt-br.js": 105,
	"./pt.js": 104,
	"./ro": 106,
	"./ro.js": 106,
	"./ru": 107,
	"./ru.js": 107,
	"./sd": 108,
	"./sd.js": 108,
	"./se": 109,
	"./se.js": 109,
	"./si": 110,
	"./si.js": 110,
	"./sk": 111,
	"./sk.js": 111,
	"./sl": 112,
	"./sl.js": 112,
	"./sq": 113,
	"./sq.js": 113,
	"./sr": 114,
	"./sr-cyrl": 115,
	"./sr-cyrl.js": 115,
	"./sr.js": 114,
	"./ss": 116,
	"./ss.js": 116,
	"./sv": 117,
	"./sv.js": 117,
	"./sw": 118,
	"./sw.js": 118,
	"./ta": 119,
	"./ta.js": 119,
	"./te": 120,
	"./te.js": 120,
	"./tet": 121,
	"./tet.js": 121,
	"./th": 122,
	"./th.js": 122,
	"./tl-ph": 123,
	"./tl-ph.js": 123,
	"./tlh": 124,
	"./tlh.js": 124,
	"./tr": 125,
	"./tr.js": 125,
	"./tzl": 126,
	"./tzl.js": 126,
	"./tzm": 127,
	"./tzm-latn": 128,
	"./tzm-latn.js": 128,
	"./tzm.js": 127,
	"./uk": 129,
	"./uk.js": 129,
	"./ur": 130,
	"./ur.js": 130,
	"./uz": 131,
	"./uz-latn": 132,
	"./uz-latn.js": 132,
	"./uz.js": 131,
	"./vi": 133,
	"./vi.js": 133,
	"./x-pseudo": 134,
	"./x-pseudo.js": 134,
	"./yo": 135,
	"./yo.js": 135,
	"./zh-cn": 136,
	"./zh-cn.js": 136,
	"./zh-hk": 137,
	"./zh-hk.js": 137,
	"./zh-tw": 138,
	"./zh-tw.js": 138
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 257;

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('toDateTimeString', function (original) {
  if (original !== null) {
    var retValue = __WEBPACK_IMPORTED_MODULE_1_moment___default()(original);
    retValue.locale('de');
    return retValue.format('L') + ' ' + retValue.format('LT');
  }
  return original;
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('toFixedNumber', function (original, decimalPlaces) {
  if (original !== null) {
    var nStr = parseFloat(original).toFixed(decimalPlaces) + '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + '\'' + '$2');
    }
    return (x1 + x2).replace(/\./g, ',').replace(/'/g, '.');
  }
  return original;
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('toMonthYearString', function (original) {
  if (original !== null) {
    var retValue = __WEBPACK_IMPORTED_MODULE_1_moment___default()(original);
    retValue.locale('de');
    return retValue.format('M/YYYY');
  }
  return original;
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('newlineToBr', function (original) {
  if (original !== null) {
    original = original.replace(/\n/g, '<br />');
  }
  return original;
});

/***/ })
],[139]);


// WEBPACK FOOTER //
// static/js/app.92b217c99957bdc9e235.js